import script from "./AccPayModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccPayModal.vue?vue&type=script&setup=true&lang=ts"

import "./AccPayModal.vue?vue&type=style&index=0&id=726c8711&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726c8711"]])

export default __exports__